import axios from "axios";
import React, { useEffect, useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Loading from "../../components/loading/Loading";
import { useNavigate } from "react-router-dom";
const Event = () => {
  const [eventData, setEventdata] = useState([]);
  const [loading, setLoading] = useState(false);
  const [eventName,setEventName] =useState()
  const navigate = useNavigate();



  const columns = [
    { field: "id", headerName: "", width: 50 },
    { field: "eventName", headerName: "Event Name", width: 330 },
    { field: "eventDate", headerName: "Event Date", width: 150 },
  ];

  useEffect(() => {
    const getEventData = async () => {
      try {
        setLoading(true);
        const response = await axios.get("/get-events");
        const mappedEvents = response.data.map((event, i) => ({
          eventName: event.eventName || "",
          eventDate: event.eventDate || "",
          id: (i + 1),
        }));
        setEventdata(mappedEvents);
      } catch (error) {
        return;
      } finally {
        setLoading(false);
      }
    };

    getEventData();
  }, []);

  return (
    <div className="main_wrp">
      <div className="main_page_wrp">
        <div className="head_wrp">
          <h3>
            All <em>Events</em>
          </h3>
        </div>
        <div className="main_body_wrp">
          {loading ? (
            <>
              <Loading />
            </>
          ) : (
            <DataGrid
              rows={eventData}
              columns={columns}
              pageSize={5}
              onCellClick={(params) => {
                navigate(
                  `/event-data/${encodeURIComponent(params.row.eventName)}`,
                );
              }}
              disableRowSelectionOnClick
              getRowId={(row) => row.id}
              slots={{ toolbar: GridToolbar }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
              sx={{
                "& .MuiDataGrid-row": {
                  cursor: "pointer",
                },
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Event;
